module.exports = __webpack_public_path__ + "img/desktop-VTA-valoracion-modificar02.0cccc5b8.png";